
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/n/[number]",
      function () {
        return require("private-next-pages/n/[number].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/n/[number]"])
      });
    }
  